import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

import { Themes } from '../../constants';
import { getThemeColor } from '../../utils/common';
import { FORTA_WHITE } from '../../utils/colors';

import type { SwitchProps as MSwitchProps } from '@mui/material/Switch';

interface SwitchProps extends MSwitchProps {
  sx?: any;
  colorTheme?: Themes;
  coloredBackground?: boolean;
  width?: number;
  height?: number;
}

const StyledSwitch = styled(
  ({ colorTheme: _colorTheme, coloredBackground: _coloredBackground, ...rest }: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...rest} />
  ),
)(({ theme, colorTheme, coloredBackground, width = 80, height = 40, sx = {} }) => ({
  width: width,
  height: height,
  padding: 0,

  '& .MuiSwitch-switchBase': {
    padding: 4,
    transitionDuration: '300ms',

    '&.Mui-checked': {
      transform: `translateX(${height}px)`,
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: getThemeColor(colorTheme).primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled': {
        color: '#fff',
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: `${height - 8}px`,
    height: `${height - 8}px`,
  },
  '& .MuiSwitch-track': {
    borderRadius: `${height / 2}px`,
    backgroundColor: coloredBackground ? getThemeColor(colorTheme).light3 : FORTA_WHITE,
    border: `2px solid ${getThemeColor(colorTheme).primary}`,
    padding: 5,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
  ...sx,
}));

function FSwitch(props: SwitchProps) {
  const { colorTheme = Themes.Primary, coloredBackground = false, width = 80, height = 40 } = props;

  return (
    <StyledSwitch
      {...props}
      colorTheme={colorTheme}
      coloredBackground={coloredBackground}
      width={width}
      height={height}
    />
  );
}

export default FSwitch;
